import React from 'react';
import DashboardLayout from '../DashboardLayout';

const PromotionLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default PromotionLayout;
